import { blue, slate, white } from '@/lib/colours';

import {
  Box,
  Checkbox,
  FormControlLabel,
  type FormControlLabelProps,
} from '@/primitives';

export interface FramedCheckboxProps
  extends Omit<FormControlLabelProps, 'control'> {}

export function FramedCheckbox(props: FramedCheckboxProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        flexBasis: 0,
        display: 'flex',
        alignItems: 'center',
        padding: '16px',
        borderRadius: '8px',
        backgroundColor: white[500],
        border: `1px solid ${slate[500]}`,
        ':has(.Mui-checked)': {
          backgroundColor: blue[50],
          border: `1px solid ${blue[600]}`,
        },
        ':has(.Mui-disabled)': {
          borderColor: 'rgba(0, 0, 0, 0.38)',
        },
      }}
    >
      <FormControlLabel control={<Checkbox />} {...props} />
    </Box>
  );
}
